import { useRouteError } from 'react-router'

export default function ErrorBoundary() {
  const error = useRouteError() as Error & { status?: number }

  console.error(error)

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <div className="bg-red-50 border border-red-200 rounded-lg p-8 text-center">
        <h1 className="text-3xl font-bold text-red-800 mb-4">哎呀，出错了！</h1>
        <p className="text-red-700 mb-2">
          {error.status ?? '未知错误'}: {error.message}
        </p>
      </div>
    </div>
  )
}
